<div mat-dialog-title class="toolbar toolbar-row">
  <span>{{ 'DIALOG_UPLOAD_FILE.TITLE' | translate }}</span>
  <span class="spacer"></span>
  <app-info-modal
    [textModal]="'DIALOG_UPLOAD_FILE.DIALOG_INFO.TEXT' | translate:{maxImageSize: MAX_IMAGE_SIZE_IN_KB, acceptedType: acceptedFileTypesDisplay }"
    [titleModal]="'DIALOG_UPLOAD_FILE.DIALOG_INFO.TITLE' | translate">
  </app-info-modal>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-offset-3 col-md-6 col-sm-offset-2 col-sm-8 top10">
      <div class="_profil">
        <img width="100" [src]="imageDisplay" />
        @if (deletable) {
          <button mat-icon-button class="delete-btn" (click)="deleteImage()"
            [matTooltip]="'DIALOG_UPLOAD_FILE.DELETE'|translate">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    </div>
    <div class="col-xs-12 top30">
      <button mat-raised-button class="col-sm-4 col-xs-12 top10" color="primary" type="button" appFilePicker
        [formatAccepted]="ACCEPTED_FILE_TYPES" (filePick)="loadImage($event)">
        {{'DIALOG_UPLOAD_FILE.BUTTON' | translate }}
      </button>
      <mat-form-field class="col-sm-8 col-xs-12">
        <input matInput class="file-display" [formControl]="loadedImageControl" readonly>
        <mat-error>
          {{ getError() }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{'COMMON.CANCEL'|translate}}</button>
  <button mat-raised-button color="primary" [disabled]="!getConfirmIsEnabled()"
  (click)="submit()">{{'COMMON.CONFIRM' | translate}}</button>
</div>
